import { MappingTipiEntitaFascicolo } from '../../common/configuration/mapping-tipi-entita-fascicolo';

export class PropertiesSettings {
  public static readonly PRODUCTION_MODE: boolean = false;
  public static readonly LOCALE_IT: string = 'it-IT';
  public static readonly SYMBOL_EURO: string = '\u20AC';
  public static readonly NEW_SEZIONE: string = 'new';
  public static readonly LAST_STEP_WIZARD: string = 'LAST_STEP_WIZARD';
  // public static readonly ID_TIPO_PERSONA_FISICA: string = '1';
  // public static readonly ID_TIPO_PERSONA_GIURIDICA: string = '2';
  public static readonly LABEL_TIPO_PERSONA_FISICA: string = 'FISICA';
  public static readonly LABEL_TIPO_PERSONA_GIURIDICA: string = 'GIURIDICA';
  // public static readonly ID_TERZO_PIGNORATO: string = '6';
  public static readonly LABEL_TERZO_PIGNORATO: string = 'TERZO PIGNORATO';
  public static readonly MSG_NO_PRATICA: string =
    'Impossibile recuperare la pratica';
  public static readonly MSG_NO_FASCICOLO: string =
    'Impossibile recuperare il fascicolo';
  public static readonly MSG_SUCCESS_COMPLETA_FASCICOLO: string =
    'Completamento del fascicolo {posizioneFascicolo}, relativo alla pratica {posizionePratica}, avvenuto con successo.';
  public static readonly MSG_GENERIC_SUCCESS: string =
    'Operazione avvenuta con successo';
  public static readonly LABEL_CREATO_DA_SISTEMA: string = 'Creato da sistema';
  public static readonly ID_TIPO_PETITUM_QUANTIFICABILE: string =
    'QUANTIFICABILE';
  public static readonly ID_TIPO_PETITUM_NON_PRESENTE: string = 'NON_PRESENTE';
  public static readonly ID_TIPO_REVISIONE_PETITUM: string = 'PETITUM';
  public static readonly ID_TIPO_REVISIONE_FONDO_RISCHI: string = 'FONDORISCHI';
  public static readonly ID_TIPO_REVISIONE_WIZARD: string = 'WIZARD';
  // public static readonly ID_ESITO_FAVOREVOLE: string = '1';
  // public static readonly ID_ESITO_SFAVOREVOLE: string = '2';
  public static readonly LABEL_ESITO_FAVOREVOLE: string = 'FAVOREVOLE';
  public static readonly LABEL_ESITO_SFAVOREVOLE: string = 'SFAVOREVOLE';
  public static readonly ID_TIPO_ESITO_SPEDIZIONE_NEGATIVO = 'NEGATIVO';
  public static readonly ID_TIPO_ESITO_SPEDIZIONE_POSITIVO = 'POSITIVO';
  public static readonly ID_TIPO_ESITO_SPEDIZIONE_IN_ATTESA_DI_ESITO =
    'IN_ATTESA_DI_ESITO';
  /*public static readonly ID_TIPO_ESITO_SENTENZA = '1';
  public static readonly ID_TIPO_ESITO_ORDINANZA = '2';
  public static readonly ID_TIPO_ESITO_DECRETO = '3';
  public static readonly ID_TIPO_ESITO_DISPOSITIVO = '4';
  public static readonly ID_TIPO_ESITO_TRANSAZIONE = '5';
  public static readonly ID_TIPO_ESITO_ACCORDO = '6';*/
  public static readonly LABEL_TIPO_ESITO_SENTENZA = 'SENTENZA';
  public static readonly LABEL_TIPO_ESITO_ORDINANZA = 'ORDINANZA';
  public static readonly LABEL_TIPO_ESITO_DECRETO = 'DECRETO';
  public static readonly LABEL_TIPO_ESITO_DISPOSITIVO = 'DISPOSITIVO';
  public static readonly LABEL_TIPO_ESITO_TRANSAZIONE = 'TRANSAZIONE';
  public static readonly LABEL_TIPO_ESITO_ACCORDO = 'ACCORDO';

  // Sezione economica liquidati
  public static readonly labelSommeAssegnate = 'somme assegnate';
  public static readonly labelSommaAssegnata = 'somma assegnata';
  public static readonly labelSommeAssegnateInitCap = 'Somme assegnate';
  public static readonly labelSommaAssegnataInitCap = 'Somma assegnata';
  public static readonly labelLiquidazioneSommaAssegnata = 'liquidazione';
  public static readonly labelLiquidati = 'liquidati';
  public static readonly labelLiquidato = 'liquidato';
  public static readonly labelLiquidatiInitCap = 'Liquidati';
  public static readonly labelLiquidatoInitCap = 'Liquidato';
  public static readonly labelLiquidazione = 'liquidazione';
  public static readonly listFascicoliChangeLabelLiquidati: Array<string> = [
    MappingTipiEntitaFascicolo.FASCICOLO_IMMOBILIARE,
    MappingTipiEntitaFascicolo.FASCICOLO_MOBILIARE,
    MappingTipiEntitaFascicolo.FASCICOLO_COTERZI,
  ];
  public static readonly listFascicoliViewTerzoPignorato: Array<string> = [
    MappingTipiEntitaFascicolo.FASCICOLO_COTERZI,
  ];
  public static readonly listFascicoliNoFondoRischi: Array<string> = [
    MappingTipiEntitaFascicolo.FASCICOLO_INDAGINI_PRELIMINARI,
    MappingTipiEntitaFascicolo.FASCICOLO_DIBATTIMENTO_PENALE,
    MappingTipiEntitaFascicolo.FASCICOLO_PARERE,
  ];

  // REGEX
  public static readonly REGEX_LONG_STRING = '(^.{0,255})$';
  public static readonly REGEX_ANNO = '^[12][0-9]{3}$';
  public static readonly REGEX_NUMERI = '^[0-9]*$';
  public static readonly REGEX_DECIMALI = '^([0-9]{1,9})([.,][0-9]{1,2})*$';
  public static readonly REGEX_CAP = '^[0-9]{5}$';
  public static readonly REGEX_LETTERE =
    "^[a-zA-Z'\\s\\340\\362\\350\\351\\354\\371\\347]+$";
  public static readonly REGEX_TELEFONO =
    '^((((\\+|00)(\\d{1,3}))(\\s|\\.|-|/|))?((\\d{3})|([0](\\d{1,3})))(\\s|\\.|-|/|)?(\\d{3,9}))$';
  //  public static readonly REGEX_PARTITA_IVA = '^([a-zA-Z]{2})?[0-9]{11}$';
  public static readonly REGEX_PARTITA_IVA = '^[0-9]{11}$';
  public static readonly REGEX_CODICE_FISCALE_RAPPRESENTANTE_LEGALE =
    '^[A-Za-z]{6}' +       // cognome e nome
    '[0-9A-Z]{2}' +        // anno (numeri o lettere omocodia)
    '[ABCDEHLMPRSTabcdehlmprst]{1}' + // mese
    '[0-9A-Z]{2}' +        // giorno (numeri o lettere omocodia)
    '[A-Za-z]{1}' +        // prima lettera del comune
    '[0-9A-Z]{3}' +        // resto codice comune (numeri o lettere omocodia)
    '[A-Za-z]{1}$';        // carattere di controllo
  public static readonly REGEX_EMAIL =
    '^[A-Za-z0-9_\\-\\.]+@[A-Za-z0-9_\\-\\.]+\\.[A-Za-z0-9_\\-\\.]{2,}$';
  public static readonly REGEX_EMAIL_PEC =
    '^[A-Za-z0-9_\\-\\.]+@pec[A-Za-z0-9_\\-\\.]+\\.[A-Za-z0-9_\\-\\.]{2,}$';
  public static readonly REGEX_DATA =
    '^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)dd$';
  public static readonly REGEX_CODICE_FISCALE =
    '^[A-Za-z]{6}' +       // cognome e nome
    '[0-9A-Z]{2}' +        // anno (numeri o lettere omocodia)
    '[ABCDEHLMPRSTabcdehlmprst]{1}' + // mese
    '[0-9A-Z]{2}' +        // giorno (numeri o lettere omocodia)
    '[A-Za-z]{1}' +        // prima lettera del comune
    '[0-9A-Z]{3}' +        // resto codice comune (numeri o lettere omocodia)
    '[A-Za-z]{1}$';        // carattere di controllo


  // UPLOAD FILE
  public static readonly UPDATE_FILE_UPLOAD_ERROR =
    'Errore in fase di aggiornamento file. Riprovare';
  public static readonly TRANSFER_UPLOAD_ERROR =
    'Errore in fase di trasferimento file. Riprovare';
  public static readonly CANCEL_UPLOAD_ERROR =
    'Upload interrotto da utente. Riprovare';

  // FS
  public static readonly IDS_FORM_TENANTS_FS: string[] = [
    'Civ_FS',
    'Lav_FS',
    'Amm_FS',
    'Par_FS',
  ];
  // public static readonly ID_TENANTS_PRD: boolean = localStorage.getItem('TLF_TENANT') === 'TNT_TENANT1';
  // public static readonly ID_TENANTS_FS: boolean = localStorage.getItem('TLF_TENANT') === 'TNT_FERROVIE';
  public static MAX_VALUE_DECIMAL: number = 999999999;
  public static ID_TENANTS_PRD() {
    // return localStorage.getItem('TLF_TENANT') === 'TNT_TENANT1';
    return localStorage.getItem('TLF_TENANT') !== 'TNT_FERROVIE';
  }
  public static ID_TENANTS_FS() {
    return localStorage.getItem('TLF_TENANT') === 'TNT_FERROVIE';
  }

  public static readonly PRATICHE_CON = ['lavoro', 'civile', 'amministrativa'];
  public static readonly PRATICHE_CD = ['pareristica'];
}
